<template>
    <div>
        <v-virtual-scroll :items="sentSMSes" height="600" item-height="130">
              <template v-slot:default="props">
                <v-list two-line>
                  <v-list-item :key="props.index + Math.random()">
                      <v-list-item-content>
                       <v-list-item-title class="mb-1">{{props.item.title }}</v-list-item-title>
                      <v-list-item-subtitle class="mb-2">{{props.item.date_time}}</v-list-item-subtitle>
                       <v-list-item-subtitle>
                        {{props.item.body }}
                       </v-list-item-subtitle>
                      <v-list-item-subtitle>
                        Sent: {{props.item.sent }} | Delivered: {{props.item.delivered }} | Rejected: {{props.item.rejected }}
                       </v-list-item-subtitle>
                        </v-list-item-content>
                        <v-list-item-action>
                        <v-checkbox
                    v-model="selectedReportsForDeleting"
                    :value="props.item.id"
                    class="shrink mb-n4"
                    dense
                    @change="sendSelectedReports()"
                  >
                  </v-checkbox>
                  <!-- <v-btn
                    color="teal"
                    x-small
                    dark
                    rounded
                    v-if="!props.item.predefine"
                    class="mb-2 mx-n4"
                    @click="reSendSMS(props.item)"
                    >Resend</v-btn
                  > -->
                        </v-list-item-action>
                  </v-list-item>
                  <v-divider></v-divider>
                </v-list>
              </template>
            </v-virtual-scroll>
    </div>
</template>

<script>
export default {
    name: 'VueElearningSentSMSList',
    props:['sentSMSes'],
    data() {
        return {
            selectedReportsForDeleting: [],
        };
    },

    mounted() {
        
    },

    methods: {
        reSendSMS(item) {
            this.$emit('resend-sms',item)
        },
        sendSelectedReports() {
        this.$emit('reports-selected',this.selectedReportsForDeleting)
    }
    },
};
</script>

<style lang="scss" scoped>

</style>